// extracted by mini-css-extract-plugin
export default {"buttons":"ULm-J _1brkc"};